<template>
  <div class="wrapper-content wrapper">
    <div class="ibox float-e-margins">
      <div class="ibox-title">
        <h5>Sites</h5>
        <div>
        </div>
        <div class="ibox-tools">
<!--          <input type="text" name="nameFilter" id="" v-model="nameFilter" @keyup="filterSites('url', nameFilter)" placeholder="Url" accesskey="u">-->
          <div>
            <button class="btn btn-xs btn-primary" @click="downloadAllTags"><i class="fa fa-download"></i> All Tags</button>
          </div>
        </div>
      </div>
      <div class="ibox-content table-responsive col-lg-12">
        <table class="table table-striped table-bordered table-hover dataTables-example">
          <thead>
          <tr>
            <th>Url</th>
            <th>Tags</th>
            <th>Lang</th>
            <th>Tags</th>
            <th>Videos</th>
            <th>Check</th>
            <th>Setup</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="site in filteredSites" :key="site.id">
            <td>
              <i :class="((site.status === 'OK') ? 'fa-check icon-ok' : (site.status === 'added') ? 'fa-gears icon-dunno' : 'fa-frown-o icon-bad' ) + ' fa'" :title="site.status"></i>
              <router-link :to="'/manager/site/' + site.url">{{ site.originalUrl }}</router-link>
              <i class="fa pull-right fa-venus-mars" style="font-weight: 900; font-size: 16px;" v-if="site.type === 'straight' || site.type === 'mixed'"></i>
              <i class="fa pull-right fa-mars-double" style="font-weight: 900; font-size: 16px; color: pink;" v-if="site.type === 'gay' || site.type === 'mixed'"></i>
            </td>
            <td>
              <div v-for="(tag, i) in site.siteTags" :key="site.id + '-' + i" class="label label-primary m-r-xs">{{ tag }}</div>
            </td>
            <td>{{ site.lang }}</td>
            <td>{{ site.tagCount }}</td>
            <td>{{ site.videoCount || '/' }}</td>
            <td>{{ site.lastPing ? $moment(site.lastPing.date).fromNow() : '/' }}</td>
            <td>
              {{ site.plugin || '/'}}
              <img src="/static/img/cloudflare.png" class="setup-icons pull-right" alt="cloudflare" title="cloudflare" v-if="site.setup.cloudflare">
              <img src="/static/img/varnish.png" class="setup-icons pull-right" alt="varnish" title="varnish cache" v-if="site.setup.varnish">
              <img src="/static/img/openlitespeed.png" class="setup-icons pull-right" alt="OpenLiteSpeed" title="OpenLiteSpeed" v-if="site.setup.liteSpeed">
              <img src="/static/img/yandex.png" class="setup-icons pull-right" alt="Yandex" title="Yandex" v-if="site.options.yandex_tag">
            </td>
          </tr>
          </tbody>
          <tfoot>
          <tr>
            <th>Url</th>
            <th>Tags</th>
            <th>Lang</th>
            <th>Tags</th>
            <th>Videos</th>
            <th>Check</th>
            <th>Setup</th>
          </tr>
          </tfoot>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { Browser } from '../../../mixins/helperMixin'
export default {
  name: 'Sites',
  data () {
    return {
      sites: null,
      nameFilter: '',
      filteredSites: [],
      filters: {}
    }
  },
  mounted () {
    this.getSites()
    document.title = 'Adult Sites :: PBN360 by Aphex Media'
  },
  methods: {
    filterSites (filter, value, type = 'string') {
      this.filteredSites = this.sites
      this.filters[filter] = value
      Object.keys(this.filters).forEach(key => {
        let val = this.filters[key]
        this.filteredSites = this.sites.filter(r => !r.url.indexOf(val))
      })
    },
    getSites () {
      axios.get('/am/sites')
        .then(r => {
          this.sites = r.data.data
          this.filteredSites = this.sites
        })
        .catch(e => {
          console.log(e)
        })
    },
    downloadAllTags () {
      axios.get('/adult/tags/list-all?format=csv')
        .then(r => {
          Browser.methods.downloadFile('all-adult-tags.csv', r.data.data)
        })
        .catch(e => {
          this.$toastr.error(e, 'This does not look to promissing')
        })
    }
  }
}
</script>

<style scoped>
.icon-dunno {
  color: orange;
}
  .icon-ok {
    color: green;
  }
  .icon-bad {
    color: red;
  }
  .setup-icons {
    max-height: 14px;
    margin-left: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Pages/Manager/Sites.vue